module.exports = __webpack_public_path__ + "static/media/level-four.4c9e1621.svg";